"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustryVoices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="8146" id="five-star-whispers" ref={ref} className={`w-full py-24 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4 font-serif tracking-tight">Happy Stays, Happy Guests</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">Happy guests mean higher returns. See how our commitment to 5-star hospitality translates into glowing reviews across our portfolio.</p>
        </div>

        <div className="relative px-4 md:px-12">
          [wprevpro_usetemplate tid="2"]
        </div>
      </div>
    </section>;
}